import { createGlobalStyle } from 'styled-components';
import { fonts } from './styled';

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
  }
  body {
    position: relative;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  html, body {
    width: 100%;
    font-family: ${fonts.primary};
    -webkit-font-smoothing: antialiased;
    touch-action: auto;
  }
  
  button:focus {
    outline: 0;
  }
  
  #app {
    height: auto;
    overflow: visible;
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }

  h1, h2, h3 {
    font-weight: normal;
  }
  
  body.scroll-lock {
    overflow: hidden;
  }
  
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
`;
